import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/environments/environment';
import { lastValueFrom } from 'rxjs';
import { LibraryWidget, ZLibraryWidget } from '@studio/domain/creativeset/widget-asset';

@Injectable({ providedIn: 'root' })
export class WidgetService {
    constructor(private http: HttpClient) {}

    private url = `${environment.origins.bannerflowLibrary}/api/widgets/`;

    async get(): Promise<LibraryWidget[]>;
    async get(id: string): Promise<LibraryWidget>;
    async get(id: string[]): Promise<LibraryWidget[]>;
    async get(sort: 'asc' | 'desc'): Promise<LibraryWidget[]>;
    async get(id: string, sort: 'asc' | 'desc'): Promise<LibraryWidget>;
    async get(id: string[], sort: 'asc' | 'desc'): Promise<LibraryWidget[]>;
    async get(
        id?: string | string[],
        sort: 'asc' | 'desc' = 'asc'
    ): Promise<LibraryWidget | LibraryWidget[]> {
        if (!id) {
            return lastValueFrom(this.http.get<LibraryWidget[]>(`${this.url}?sort=${sort}`));
        }

        if (!Array.isArray(id)) {
            const response = await lastValueFrom(
                this.http.get<LibraryWidget>(`${this.url + id}?sort=${sort}`)
            );
            return ZLibraryWidget.parse(response[0]);
        }

        const response = await lastValueFrom(
            this.http.get<LibraryWidget>(`${this.url + id.join(',')}?sort=${sort}`)
        );
        return ZLibraryWidget.parse(response);
    }

    async post(widget: LibraryWidget): Promise<LibraryWidget> {
        return lastValueFrom(this.http.post<LibraryWidget>(this.url, widget));
    }

    async put(widget: LibraryWidget): Promise<LibraryWidget> {
        return lastValueFrom(
            this.http.put<LibraryWidget>(this.url + widget.id, this.serialize(widget))
        );
    }

    private serialize(widget: LibraryWidget): LibraryWidget {
        const w = { ...widget };
        delete w.versionId;
        return w;
    }

    public openInfoPage(): void {
        window.open('https://support.bannerflow.com/en/articles/5306363-widgets-overview', '_blank');
    }
}
